import './CategoryGamesGrid.scss';

import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import AppError from '../../pages/errors/AppError';
import { useFlag } from '../../services/launchDarkly';
import type { Game } from '../../stores/game/types';
import { useStores } from '../../stores/useStores';

import { GameCard } from './GameCard';
import { useGamesSeen } from './hooks/useGamesSeen';
import GamesLoader from './Loader';
import MoreGames from './MoreGames';
import { NoGamesFound } from './NoGamesFound';
import { seenGamesGridListener } from './seenGamesImpression';
import Title from './Title';

export const SearchGamesGrid = observer(() => {
  const { categoriesStore, gamesSearchStore } = useStores();
  const { t } = useTranslation();
  const { currentCategory } = categoriesStore;

  const gameLabelFF = useFlag('game_labels_feat', true);

  useGamesSeen(seenGamesGridListener);

  const isLoading = categoriesStore.loading.get('search-games') || categoriesStore.loading.get('pagination');

  if (categoriesStore.loading.get('search-games')) {
    return <GamesLoader />;
  }

  if (!currentCategory) {
    return <AppError error={new Error('search-games error')} />;
  }

  const noGamesFound = !currentCategory.subCategoryGames.length && !isLoading;

  const filterUniqueGames = (games: Game[]) => {
    const seen = new Set();
    return games.filter((game) => {
      const duplicate = seen.has(game.masterCasinoGameId);
      seen.add(game.masterCasinoGameId);
      return !duplicate;
    });
  };

  const uniqueGames = filterUniqueGames(currentCategory.subCategoryGames);
  const rowName = 'search';

  if (noGamesFound) {
    return <div className="games-grid-wrapper">{noGamesFound && <NoGamesFound />}</div>;
  }

  return (
    <div className="games-grid-wrapper">
      {gamesSearchStore.isRecentlyPlayedShowed && (
        <div className="games__category-wrapper">
          <Title name={t('games.recentlyPlayed')} />
        </div>
      )}
      <div className="games-grid" data-games-row={rowName}>
        {uniqueGames.map((game) => (
          <GameCard key={game.masterCasinoGameId} game={game} gameLabelFF={gameLabelFF} rowName={rowName} />
        ))}
      </div>
      {categoriesStore.loading.get('pagination') ? <GamesLoader /> : currentCategory.hasMoreGames && <MoreGames />}
    </div>
  );
});
